// Chakra Icons
import { BellIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Box, Button,
  useDisclosure,
  Image,
  Flex,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Menu,
  MenuButton,
  MenuItem,
  Icon,
  IconButton,
  Input,
  MenuList, Stack, Text, useColorMode,
  useColorModeValue,
  Link,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Grid,
  FormHelperText,

} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import NiceButton from "components/NiceButton/NiceButton.js";
import logoDark from "assets/img/logo-dark.png";

// Assets
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
import { RiLogoutBoxRFill } from "react-icons/ri";
// Custom Icons
import { SettingsIcon, CreditIcon, ProfileIcon, RocketIcon, PasswordLogo } from "components/Icons/Icons";
// Custom Components
import { ItemContent } from "components/Menu/ItemContent";
import { SearchBar } from "components/Navbars/SearchBar/SearchBar";
import { SidebarResponsive } from "components/Sidebar/Sidebar";
import FromNow from "components/TimeAgo/index";
import React from "react";
import { NavLink } from "react-router-dom";
import routes from "routes.js";
import { getGlobal } from "config/global";
import { useEffect, useState } from "react";
import changePassword from "api/authenticate/change-password";
import { ToastContainer, toast } from 'react-toastify';
import completeRegistration from "api/authenticate/complete-rgistration";
import { useHistory, useLocation } from "react-router-dom";
import allmessage from "api/message/list";
import moment from "moment";
import read from "api/message/read";
import { setGlobal } from "config/global";

export default function HeaderLinks(props) {
  const {
    variant,
    children,
    fixed,
    scrolled,
    secondary,
    onOpen,
    ...rest
  } = props;
  const history = useHistory();
  let exit = function () {
    localStorage.removeItem('token')
    window.location = "/auth/signIn";
  }
  let me = getGlobal("me")
  const [isLoading, setIsLoading] = useState(false);
  const [isNameLoading, setIsNameLoading] = useState(false);
  const [name, setName] = useState("");
  const [last, setLast] = useState("");
  const [reload, setReload] = useState(false);
  const [messages, setMessages] = useState([]);
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const { isOpen: isChangePasswordOpen, onOpen: OnChangePasswordOpen, onClose: onChangePasswordClose } = useDisclosure()
  const { isOpen: isNameOpen, onOpen: OnNameOpen, onClose: onNameClose } = useDisclosure()
  const { colorMode } = useColorMode();
  // Color Mode
  let navbarIcon =
    fixed && scrolled
      ? useColorModeValue("gray.700", "gray.200")
      : useColorModeValue("white", "gray.200");
  let menuBg = useColorModeValue("white", "navy.800");
  let bellColor = useColorModeValue("green.200", "green.400");
  if (secondary) {
    navbarIcon = "white";
  }
  function change() {
    setIsLoading(true)
    if (password != passwordRepeat) {
      setIsLoading(false)
      return toast.error("پسوردها یکسان نیستند.", {
        position: "bottom-right"
      })
    }
    changePassword(password).then((result) => {
      toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
      setPassword("")
      setPasswordRepeat("")
      onChangePasswordClose()
      localStorage.removeItem("token")
      window.location = ("/auth/signin");
    }).catch((err) => {
      console.error(err)
      if (err?.response?.status == 409)
        return toast.error("آدرس انتخابی تکراری است.", {
          position: "bottom-right"
        })
      else if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsLoading(false)
    })
  }
  useEffect(() => {
    setInterval(()=>{
        setReload(!reload)
        console.log(reload)
    },60000*3)
    setName(me?.name)
    setLast(me?.name)
  }, [])
  function change_name() {
    setIsNameLoading(true)
    completeRegistration(name).then((result) => {
      toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
      setLast(name)
      onNameClose()
    }).catch((err) => {
      console.error(err)
      if (err?.response?.status == 409)
        return toast.error("آدرس انتخابی تکراری است.", {
          position: "bottom-right"
        })
      else if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsNameLoading(false)
    })
  }

  useEffect(() => {
    setIsLoading(true)
    allmessage().then((result) => {
      setMessages(result.data)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsLoading(false)
    })
  }, [reload])
  function changeRead() {
    me.readDate=moment()
    setGlobal({
      me
    })
    read().then(() => {
      setReload(!reload)
    })
  }
  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems='center'
      flexDirection='row'>
      <Menu>
        <MenuButton>
          <Button
            ms='0px'
            px='0px'
            me={{ sm: "2px", md: "16px" }}
            color={navbarIcon}
            variant='no-effects'
            rightIcon={
              document.documentElement.dir ? (
                ""
              ) : (
                <ProfileIcon color={navbarIcon} w='22px' h='22px' me='0px' />
              )
            }
            leftIcon={
              document.documentElement.dir ? (
                <ProfileIcon color={navbarIcon} w='22px' h='22px' me='0px' />
              ) : (
                ""
              )
            }>
            <Text fontSize="xs" display={{ sm: "none", md: "flex" }}>{name ? name : "مهمان"}</Text>
          </Button>
        </MenuButton>
        <Button
          onClick={() => history.push("/admin/profile")}
          ms='0px'
          px='0px'
          me={{ sm: "2px", md: "16px" }}
          color={navbarIcon}
          variant='no-effects'
          rightIcon={
            document.documentElement.dir ? (
              ""
            ) : (
              <RocketIcon color={navbarIcon} w='22px' h='22px' me='0px' />
            )
          }
          leftIcon={
            document.documentElement.dir ? (
              <RocketIcon color={navbarIcon} w='22px' h='22px' me='0px' />
            ) : (
              ""
            )
          }>
          <Link fontSize="xs" onClick={() => history.push("/admin/profile")} display={{ sm: "none", md: "flex" }}>پلن فعال: {me?.plan ? me?.plan?.title : "پایه"}</Link>
        </Button>
        <MenuList p='16px 8px' bg={menuBg}>
          <Flex flexDirection='column'>
            <MenuItem borderRadius='8px' mb='10px'>
              <Link
                w="100%"
                fontSize="xs"
                onClick={OnNameOpen}>
                <ProfileIcon w='22px' h='22px' me='5px' />
                {document.documentElement.dir === "rtl"
                  ? me?.name ? "تغییر نام و نام خانوادگی" : "ثبت نام و نام خانوادگی"
                  : me?.name ? "Change Name" : "Set Name"}
              </Link>
            </MenuItem>
            <MenuItem borderRadius='8px' mb='10px'>
              <Link
                w="100%"
                fontSize="xs"
                onClick={OnChangePasswordOpen}>
                <PasswordLogo w='22px' h='22px' me='5px' />
                {document.documentElement.dir === "rtl"
                  ? "تغییر رمز عبور"
                  : "Change Password"}
              </Link>
            </MenuItem>
            <MenuItem borderRadius='8px' mb='10px' onClick={exit}>
              <Link fontSize="xs">
                <IconBox as='box' >
                  <Icon ml="10px" h={"24px"} w={"24px"} as={RiLogoutBoxRFill} />
                  {document.documentElement.dir === "rtl"
                    ? "خروج"
                    : "Exit"}
                </IconBox>
              </Link>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
      <SidebarResponsive
        hamburgerColor={"white"}
        logo={
          <Stack direction='row' spacing='12px' align='center' justify='center'>
            {colorMode === "dark" ? (
              <Image height={"74px"} src={logoDark} ></Image>
            ) : (
              <Image height={"74px"} src={logoDark} ></Image>

            )}

          </Stack>
        }
        colorMode={colorMode}
        secondary={props.secondary}
        routes={routes}
        {...rest}
      />
      <SettingsIcon
        cursor='pointer'
        ms={{ base: "16px", xl: "0px" }}
        me='16px'
        onClick={props.onOpen}
        color={navbarIcon}
        w='18px'
        h='18px'
      />

      <Menu>
        <MenuButton onClick={() => { changeRead() }}>
          {
            (messages&&messages.isNew)
            ?
              <BellIcon className={"face"} color={bellColor} w='18px' h='18px' />
            :
              <BellIcon color={navbarIcon} w='18px' h='18px' />
          }


        </MenuButton>
        <MenuList p='16px 8px' bg={menuBg}>
          <Flex flexDirection='column'>
            {messages && messages?.messages?.map((item) => {
              return <MenuItem borderRadius='8px' mb='10px'>
                <ItemContent
                  time={FromNow(item.createdAt)}
                  aName={item.avetar}
                  info={item.title}
                  boldInfo={item.summary}
                  aSrc={item.avetar}
                  text={item.text}
                />
              </MenuItem>
            })}
          </Flex>
        </MenuList>
      </Menu>
      <Modal
        isOpen={isChangePasswordOpen}
        onClose={onChangePasswordClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">تغییر رمز عبور</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            <FormControl mt={"20px"} id="title">
              <FormLabel fontSize={"sm"}>رمز عبور</FormLabel>
              <Input dir="ltr" value={password} onChange={e => setPassword(e.target.value)} type="password" />
            </FormControl>
            <FormControl mt={"20px"} id="title">
              <FormLabel fontSize={"sm"}>تکرار رمز عبور</FormLabel>
              <Input dir="ltr" value={passwordRepeat} onChange={e => setPasswordRepeat(e.target.value)} type="password" />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isLoading}
              onClick={change}
              fontSize='xs'
              w="100px"
            >
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isNameOpen}
        onClose={() => { onNameClose(); setName(last) }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">{me?.name ? "تغییر نام و نام خانوادگی" : "ثبت نام و نام خانوادگی"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            <FormControl mt={"20px"} id="title">
              <FormLabel fontSize={"sm"}>نام و نام خانوادگی</FormLabel>
              <Input value={name} onChange={e => setName(e.target.value)} type="text" />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isNameLoading}
              onClick={change_name}
              fontSize='xs'
              w="100px"
            >
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}